module.exports = __webpack_public_path__ + "static/img/top-title.de47b9dc.png";